import Form from './Form'
import Pick from './Pick'
import Story from './Story'

export default {
    Form,
    Pick,
    Story
}